export enum ErrorCode {
  BitmovinPlayerLicensingError = 1103,
  SetupMissingLicenseWhitelist = 1105,
  QualityChangeThresholdExceeded = 10000,
  BufferingTimeoutReached = 10001,
}
